import { useMutation, useQueryClient } from '@tanstack/vue-query'
import { getApi } from '../api'

/**
 * Renames a type. Trackers reference it by id, so every tracker carrying it follows the new name —
 * which is why the device queries are invalidated alongside the vocabulary.
 */
export default () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({
      accountId,
      id,
      name,
    }: {
      accountId: number
      id: number
      name: string
    }) => {
      const { api, baseURL } = getApi()
      return api
        .put(
          `/api/v2/accounts/${accountId}/container-types/${id}`,
          { name },
          { baseURL, allow404: true },
        )
        .then((res) => res.data.data)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['account-container-types'] })
      queryClient.invalidateQueries({ queryKey: ['account-device'] })
    },
  })
}
